/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual backend logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_include_tag 'backend' %> to the appropriate
// layout file, like app/views/layouts/backend.html.erb

// JS libraries
import "../scripts/frontend/setup_jquery.js";

// Hotwired
import "@hotwired/turbo-rails"

// Stimulus
import { Application } from '@hotwired/stimulus';
import { registerControllers } from 'stimulus-vite-helpers'
import Reveal from 'stimulus-reveal-controller';

import Rails from 'rails-ujs';
Rails.start();
import "@tabler/core/dist/js/tabler.min"

import RedirectOnChange from '../scripts/controllers/redirect_on_change_controller';
import UploadWidget from '../scripts/controllers/upload_widget_controller';

import areaCheckboxPicker from '../scripts/backend/area_checkbox_picker_controller';
import artistCategoriesController from '../scripts/backend/artist/categories_controller';
import autocomplete from '../scripts/backend/autocomplete_controller';
import CheckboxTreeController from '../scripts/backend/checkbox_tree_controller';
import categoryCheckboxPicker from '../scripts/backend/category_checkbox_picker_controller';
import ProfileNameController from '../scripts/backend/profile_name_controller';
import SubmitOnConnectController from '../scripts/backend/submit_on_connect_controller';
import tagSelector from '../scripts/backend/tag_selector_controller';
import FormSubmitController from '../scripts/backend/form_submit_controller';
import OfferRequestCategoriesController from '../scripts/backend/offer_request/categories_controller';

window.Rails = Rails;

const application = Application.start();
const controllers = import.meta.glob('../scripts/controllers/*_controller.js', {eager: true})
registerControllers(application, controllers)

application.register('area-checkbox-picker', areaCheckboxPicker);
application.register('artist-categories', artistCategoriesController);
application.register('autocomplete', autocomplete);
application.register('category-checkbox-picker', categoryCheckboxPicker);
application.register('checkbox-tree', CheckboxTreeController);
application.register('submit-on-connect', SubmitOnConnectController);
application.register('redirect-on-change', RedirectOnChange);
application.register('reveal', Reveal);
application.register('tag-selector', tagSelector);
application.register('upload-widget', UploadWidget);
application.register('profile-name', ProfileNameController);
application.register('form-submit', FormSubmitController);
application.register('offer-request-categories', OfferRequestCategoriesController);
